"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmartWeaveTags = void 0;
/**
 * Definition of all transaction tags used by the SmartWeave "protocol"
 */
var SmartWeaveTags;
(function (SmartWeaveTags) {
    SmartWeaveTags["APP_NAME"] = "App-Name";
    SmartWeaveTags["APP_VERSION"] = "App-Version";
    SmartWeaveTags["CONTRACT_TX_ID"] = "Contract";
    SmartWeaveTags["INPUT"] = "Input";
    SmartWeaveTags["CONTENT_TYPE"] = "Content-Type";
    SmartWeaveTags["CONTRACT_SRC_TX_ID"] = "Contract-Src";
    SmartWeaveTags["SDK"] = "SDK";
    SmartWeaveTags["MIN_FEE"] = "Min-Fee";
    SmartWeaveTags["INIT_STATE"] = "Init-State";
    SmartWeaveTags["INIT_STATE_TX"] = "Init-State-TX";
    SmartWeaveTags["INTERACT_WRITE"] = "Interact-Write";
    SmartWeaveTags["WASM_LANG"] = "Wasm-Lang";
    SmartWeaveTags["WASM_LANG_VERSION"] = "Wasm-Lang-Version";
    SmartWeaveTags["WASM_META"] = "Wasm-Meta";
    SmartWeaveTags["REQUEST_VRF"] = "Request-Vrf";
})(SmartWeaveTags = exports.SmartWeaveTags || (exports.SmartWeaveTags = {}));
//# sourceMappingURL=SmartWeaveTags.js.map